import React, { useRef } from 'react';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { Button, ArrowToRight } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InputField = styled(Primitive.input, {
  backgroundColor: '$white',
  borderRadius: '$100',
  border: 'none',
  paddingX: '$300',
  paddingY: '$200',
  width: '100%',
  height: '56px'
});

var InputCta = function InputCta(props) {
  var _props$cta2;

  var inputElement = useRef(null);

  var onSignUpClick = function onSignUpClick() {
    var _inputElement$current, _props$cta, _props$cta$href;

    var inputValue = (_inputElement$current = inputElement.current) === null || _inputElement$current === void 0 ? void 0 : _inputElement$current.value;
    var finalHref = props === null || props === void 0 ? void 0 : (_props$cta = props.cta) === null || _props$cta === void 0 ? void 0 : (_props$cta$href = _props$cta.href) === null || _props$cta$href === void 0 ? void 0 : _props$cta$href.replace('{{input}}', inputValue);

    if (finalHref) {
      window.location.href = finalHref;
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InputField, {
      ref: inputElement,
      placeholder: props.placeholder
    }), /*#__PURE__*/_jsx("div", {
      className: "button-wrapper",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onSignUpClick,
        endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
        rounded: true,
        size: "medium",
        variant: "primary",
        children: props === null || props === void 0 ? void 0 : (_props$cta2 = props.cta) === null || _props$cta2 === void 0 ? void 0 : _props$cta2.text
      })
    })]
  });
};

export default InputCta;